import React, { FC, ReactNode } from 'react';
import { Box, Button, Typography, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';

interface AuthFormProps {
  title: string;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  children: ReactNode;
  submitLabel?: string;
  error?: string | null;
}

export const AuthForm: FC<AuthFormProps> = ({
  title,
  onSubmit,
  children,
  submitLabel,
  error,
}) => {
  return (
    <Box
      component="form"
      onSubmit={onSubmit}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: '100%',
      }}
    >
      <Typography variant="h4" component="h1" gutterBottom align="center">
        {title}
      </Typography>

      {error && (
        <Typography color="error" align="center">
          {error}
        </Typography>
      )}

      {children}

      {submitLabel && (
        <Button
          type="submit"
          variant="contained"
          color="secondary"
          size="large"
          fullWidth
          sx={{ mt: 2 }}
        >
          {submitLabel}
        </Button>
      )}
    </Box>
  );
};

interface AuthLinkProps {
  to: string;
  children: ReactNode;
}

export const AuthLink: FC<AuthLinkProps> = ({ to, children }) => (
  <MuiLink component={Link} to={to} underline="hover">
    {children}
  </MuiLink>
);
